export const sendFileEmailContactType = Object.freeze({
  Me: 0,
  Insured: 1,
  InsuredContact: 2,
  InsuranceAgency: 3,
  Agent: 4,
});